var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-list-wrap"},_vm._l((_vm.listData),function(item){return _c('span',{key:item.id,class:item.name==_vm.currentName?'list-item active':'list-item',on:{"click":function($event){return _vm.chooseItem(item.name)}}},[_vm._v(_vm._s(item.name))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ba25877","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/defaultList.vue
// module id = null
// module chunks = 